"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubTrancheMarginaleImpositionTrads = void 0;
exports.ESubTrancheMarginaleImpositionTrads = {
    percent_0: "0%",
    percent_11: "11%",
    percent_30: "30%",
    percent_41: "41%",
    percent_45: "45%",
};
